<template>
    <router-link class="toolmain" :to="address">
        <div class="top">
            <img class="img" :src="img"/>
            <span class="top-a">{{toolname}}</span>
        </div>
        <p class="detail">{{detail}}</p>
        <div class="bottom">
            <span class="left">{{Charging}}</span>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "DBTool",
    props:["toolname","detail","img","address","Charging"]
}
</script>

<style lang="less" scoped>
     @media(min-width: 769px){
        .toolmain {
            display: block;
            text-decoration: none;
            box-sizing: border-box;
            margin-left: 10px;
            margin-top: 10px;
            padding: 5px;
            width: 290px;
            height: 150px;
            border: rgb(222, 226, 230) 1px solid;
            border-radius: 8px;
            font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
            transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.2s ease;
            .top {
                margin-top: 6px;
                height: 60px;
                border-bottom: rgb(222, 226, 230) 1px solid;
                color: #333333;
                .img{
                    float: left;
                    height: 50px;
                    width: 50px;
                    margin-left: 10px;
                    border-radius: 50%;
                    border: rgb(222, 226, 230) 1px solid;
                    transition: transform 0.25s ease;
                }
                .top-a{
                    margin-left: 10px;
                    color: #333;
                    cursor: pointer;
                    font-weight: bold;
                    line-height: 30px;
                }
            }
            .detail{
                font-size: 14px;
                line-height: 30px;
                color: #212529;
                padding: 8px 0 4px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .bottom{
                height: 30px;
                line-height: 30px;
                position: relative;
                .left{
                    color: rgb(153, 153, 153);
                }
            }
        }
        .toolmain:hover {
            transform: translateY(-6px) scale(1.02);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(64, 158, 255, 0.2);
            border-color: rgba(64, 158, 255, 0.4);
            .top .img {
                transform: scale(1.08);
            }
        }
    }
    @media(max-width: 768px){
        .toolmain {
            display: block;
            text-decoration: none;
            margin-left: 3vw;
            margin-top: 1vw;
            padding: 1vw;
            width: 92vw;
            height: 20vh;
            border: rgb(222, 226, 230) 1px solid;
            border-radius: 8px;
            font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            .top {
                margin-top: 6px;
                height: 7vh;
                border-bottom: rgb(222, 226, 230) 1px solid;
                color: #333333;
                .img{
                    float: left;
                    height: 50px;
                    width: 50px;
                    margin-left: 10px;
                    border-radius: 50%;
                    border: rgb(222, 226, 230) 1px solid;
                }
                .top-a{
                    margin-left: 10px;
                    color: #333;
                    cursor: pointer;
                    font-weight: bold;
                    line-height: 30px;
                }
            }
            .detail{
                font-size: 14px;
                line-height: 5.2vh;
                color: #212529;
                padding: 8px 0 4px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .bottom{
                height: 5.2vh;
                line-height: 5.2vh;
                position: relative;
                .left{
                    color: rgb(153, 153, 153);
                }
            }
        }
        .toolmain:hover {
            transform: scale(1.02);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
    }
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .toolmain {
    border-color: var(--border-color) !important;
    background: var(--bg-card) !important;
    .top {
        border-bottom-color: var(--border-color) !important;
        color: var(--text-primary) !important;
        .img { border-color: var(--border-color) !important; }
        .top-a { color: var(--text-primary) !important; }
    }
    .detail { color: var(--text-regular) !important; }
    .bottom .left { color: var(--text-secondary) !important; }
}
.dark-mode .toolmain:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(64, 158, 255, 0.3) !important;
    border-color: rgba(64, 158, 255, 0.4) !important;
}
</style>